import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    // barImage: 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-1.jpg',
    drawer: null,
    site_url: '',
    partner_id: '',
    partner_url: '',
    site_id: '',
    page_id: '',
    page_name: '',
    page_markdown: '',
    site_page_01: '',
    site_page_02: '',
    site_page_03: '',
    pages: [],
    page_ids: [],
    site_color: '',
    site_logo: '',
    from_review: false,
    site_review_open: true,
    site_link_open: false,
    popup_id: '',
    popup_name: '',
    popup_description: '',
    popup_image: '',
    popup_button_flag: false,
    popup_button_url: '',
    popup_button_name: '',
    site_font_family: '',
    letter_id: '',
    letter_name: '',
    letter_markdown: '',
    voice_open: false,
    voice_name: '',
    voice_markdown: '',
    voice_url: '',
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_SCRIM (state, payload) {
      state.barColor = payload
    },
    SET_SITE_URL (state, payload) {
      state.site_url = payload
    },
    SET_PARTNER_ID (state, payload) {
      state.partner_id = payload
    },
    SET_PARTNER_URL (state, payload) {
      state.partner_url = payload
    },
    SET_SITE_ID (state, payload) {
      state.site_id = payload
    },
    SET_SITE_PAGE_01 (state, payload) {
      state.site_page_01 = payload
    },
    SET_SITE_PAGE_02 (state, payload) {
      state.site_page_02 = payload
    },
    SET_SITE_PAGE_03 (state, payload) {
      state.site_page_03 = payload
    },
    SET_PAGE_ID (state, payload) {
      state.page_id = payload
    },
    SET_PAGE_NAME (state, payload) {
      state.page_name = payload
    },
    SET_PAGE_MARKDOWN (state, payload) {
      state.page_markdown = payload
    },
    SET_VOICE_OPEN (state, payload) {
      state.voice_open = payload
    },
    SET_VOICE_NAME (state, payload) {
      state.voice_name = payload
    },
    SET_VOICE_MARKDOWN (state, payload) {
      state.voice_markdown = payload
    },
    SET_VOICE_URL (state, payload) {
      state.voice_url = payload
    },
    SET_SITE_COLOR (state, payload) {
      state.site_color = payload
    },
    SET_SITE_LOGO (state, payload) {
      state.site_logo = payload
    },
    SET_FROM_REVIEW (state, payload) {
      state.from_review = payload
    },
    SET_SITE_REVIEW_OPEN (state, payload) {
      state.site_review_open = payload
    },
    SET_SITE_LINK_OPEN (state, payload) {
      state.site_link_open = payload
    },
    SET_POPUP_ID (state, payload) {
      state.popup_id = payload
    },
    SET_POPUP_NAME (state, payload) {
      state.popup_name = payload
    },
    SET_POPUP_DESCRIPTION (state, payload) {
      state.popup_description = payload
    },
    SET_POPUP_IMAGE (state, payload) {
      state.popup_image = payload
    },
    SET_POPUP_BUTTON_FLAG (state, payload) {
      state.popup_button_flag = payload
    },
    SET_POPUP_BUTTON_URL (state, payload) {
      state.popup_button_url = payload
    },
    SET_POPUP_BUTTON_NAME (state, payload) {
      state.popup_button_name = payload
    },
    SET_SITE_FONT_FAMILY (state, payload) {
      state.site_font_family = payload
    },
    SET_LETTER_ID (state, payload) {
      state.letter_id = payload
    },
    SET_LETTER_NAME (state, payload) {
      state.letter_name = payload
    },
    SET_LETTER_MARKDOWN (state, payload) {
      state.letter_markdown = payload
    },
  },
  actions: {

  },
  plugins: [createPersistedState()],
})
